import { atom } from "jotai";

export interface GoogleFundingChoices {
  isReady: boolean;
}

export const googleFundingChoicesAtom = atom<GoogleFundingChoices>({
  isReady: false,
});
